import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from '../reportingMessages';
import { FaFillDrip } from 'react-icons/fa';

const GlobalActionsButton = props => {
  const { intl, disabled, onBatchFillGaps, inProgress } = props;

  return (
    <span className="tool-tip" data-toggle="tooltip" data-placement="top">
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled || inProgress}
        pullRight
        title={
          <span>
            {inProgress && <i className="fa fa-spinner fa-spin margin5R" />}
            <FormattedMessage {...messages.GlobalActions} />
          </span>
        }
      >
        <MenuItem
          eventKey="2"
          onSelect={() =>
            onBatchFillGaps({
              resourceType: 4,
            })
          }
        >
          <FaFillDrip className="react-icon fa-fw margin5R" />
          <FormattedMessage {...messages.FillPeriodWithRecup} />
        </MenuItem>
        {/* <MenuItem
          eventKey="3"
          onSelect={() =>
            onBatchFillGaps({
              resourceType: 3,
            })
          }
        >
          <FaFillDrip className="react-icon fa-fw margin5R" />
          <FormattedMessage {...messages.FillPeriodWithAbsence} />
        </MenuItem> */}
      </DropdownButton>
    </span>
  );
};

GlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  onBatchFillGaps: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  inProgress: PropTypes.bool,
};
GlobalActionsButton.defaultProps = { disabled: false, inProgress: false };
export default GlobalActionsButton;
